import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstancePreviousEvCodeFields } from "../Entity/TreeNodeSubstancePreviousEvCodeFields";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstancePreviousEvCodeFieldsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Previous EV Codes ({param})');
      this.parent = parent;
      this.labelNodeName = 'Previous EV Codes';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeSubstancePreviousEvCodeFields(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let previousevcodes: Art57Node[] = [];
      this.children?.forEach((node) => {
        let previousevcode = node as Art57Node;
        previousevcodes.push(previousevcode.getMessage());
      });
  
      if (previousevcodes.length > 0) {
        return { previousevcodes: { previousevcode: previousevcodes } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Previous EV Code'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstancePreviousEvCodeFieldsList =
        new TreeNodeSubstancePreviousEvCodeFieldsList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }